export default __webpack_public_path__ + "static/media/SIW300_M060_W00.9c1d3c56.webp";